import accedo from './accedo/accedo';
import local from './local/local';

const idp = { ...local, ...accedo };

export default idp;
